import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormGroup, Switch } from '@mui/material';
import HelpIcon from './HelpIcon';

const PatternConfigDialog = ({ open, onClose, maConfigs, onApply }) => {
  const [localMaConfigs, setLocalMaConfigs] = React.useState(maConfigs);

  React.useEffect(() => {
    if (open) {
      setLocalMaConfigs(maConfigs);
    }
  }, [open, maConfigs]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>

      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Configure Moving Averages</span>
        <HelpIcon helpKey="patternConfigDialog" />
      </DialogTitle>
      <DialogContent>
                <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Moving Averages</div>
        <FormGroup>
          {localMaConfigs.map((ma, idx) => (
            <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8, gap: 8 }}>
              <Switch
                checked={ma.enabled}
                onChange={(_, checked) => {
                  setLocalMaConfigs(prev => prev.map((m, i) => i === idx ? { ...m, enabled: checked } : m));
                }}
                color="primary"
              />
              <span style={{ width: 32, fontWeight: 500 }}>{`MA${idx + 1}`}</span>
              <span>Period:</span>
              <input
                type="number"
                min={1}
                max={500}
                value={ma.period}
                style={{ width: 60, marginRight: 8 }}
                onChange={e => {
                  const val = Math.max(1, Math.min(500, Number(e.target.value)));
                  setLocalMaConfigs(prev => prev.map((m, i) => i === idx ? { ...m, period: val } : m));
                }}
              />
              <span>Color:</span>
              <input
                type="color"
                value={ma.color}
                style={{ width: 32, height: 24, border: 'none', background: 'none' }}
                onChange={e => {
                  setLocalMaConfigs(prev => prev.map((m, i) => i === idx ? { ...m, color: e.target.value } : m));
                }}
              />
            </div>
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => onApply(localMaConfigs)} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
};

PatternConfigDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
    maConfigs: PropTypes.array.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default PatternConfigDialog;
